import { RoomCarouselItemComponent } from './room-carousel-item';
import { RoomCarouselItemBottomComponent } from './room-carousel-item-bottom';
import { RoomDetailsComponent } from './room-details';
import { TypeItemComponent } from './type-item';

export * from './room-carousel-item';
export * from './room-carousel-item-bottom';
export * from './room-details';
export * from './type-item';


export const RoomAtoms = [
    RoomCarouselItemComponent,
    RoomCarouselItemBottomComponent,
    RoomDetailsComponent,
    TypeItemComponent,
]